import {useState} from "react";
import {useLocation, useOutletContext, useParams} from "react-router-dom";

import {useNavigateWithReload} from "base/hooks";
import EditIcon from "@mui/icons-material/Edit";
import {BombeoForm} from "../presentational/form";
import {SectionCardHeaderAction} from "base/component/presentational";
import {BombeoService} from "saneamiento/service";
import {bombeo_view_adapter} from "saneamiento/model";
import {BombeoLocationSection} from "../presentational/section";
import {SisbagalSectionCard} from "sisbagal/auth";

const UpdateBombeoGeoPanel = () => {
    const {section} = useParams();
    const location = useLocation();
    const baseLocationPath = location.pathname.split(section)[0];

    const [mode, setMode] = useState("view");
    const [error, setError] = useState("");
    const navigate = useNavigateWithReload();

    let bombeo;
    [bombeo] = useOutletContext();

    const handleSubmit = bombeo => {
        BombeoService.update(bombeo_view_adapter({...bombeo}))
            .then(() => {
                navigate(location.pathname, true);
            })
            .catch(error => {
                setError(error);
            });
    };

    const handleFormCancel = () => {
        setMode("view");
    };

    const secondaryActions = [
        <SectionCardHeaderAction
            key="edit"
            name="edit"
            text="Modificar"
            icon={<EditIcon />}
            onClick={() => {
                setMode("edit");
            }}
            roles={[]}
        />,
    ];

    return (
        <SisbagalSectionCard title="Ubicación" secondaryActions={secondaryActions}>
            {mode === "edit" ? (
                <BombeoForm
                    bombeo={bombeo}
                    updatedSection="geo"
                    onSubmit={handleSubmit}
                    onCancel={handleFormCancel}
                />
            ) : (
                <BombeoLocationSection bombeo={bombeo} />
            )}
        </SisbagalSectionCard>
    );
};

export default UpdateBombeoGeoPanel;
